














































import { defineComponent, ref } from '@vue/composition-api';
import { ButtonType } from '@getaccept/lib-ui';

export default defineComponent({
  props: {
    templateName: {
      type: String,
      default: null,
    },
    showBackButton: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const name = ref(props.templateName || '');
    const companyName = ref('');

    return {
      name,
      companyName,
      ButtonType,
    };
  },
});
